interface AuthorProfile {
  full_name: string;
  email?: string;
  bio?: string;
  job_title?: string;
  expertise_areas?: string[];
  linkedin_url?: string;
  twitter_url?: string;
  website_url?: string;
  credentials?: string;
  avatar_url?: string;
  author_slug?: string;
}

/**
 * Generate rich Person schema for author with E-E-A-T signals
 */
export const generateAuthorPersonSchema = (author: AuthorProfile) => {
  const baseUrl = window.location.origin;
  const sameAs: string[] = [];
  
  if (author.linkedin_url) sameAs.push(author.linkedin_url);
  if (author.twitter_url) sameAs.push(author.twitter_url);
  if (author.website_url) sameAs.push(author.website_url);
  
  return {
    "@type": "Person",
    name: author.full_name || "iQ Team",
    ...(author.job_title && { jobTitle: author.job_title }),
    ...(author.author_slug && { url: `${baseUrl}/blog/author/${author.author_slug}` }),
    ...(author.bio && { description: author.bio }),
    ...(author.avatar_url && { image: author.avatar_url }),
    ...(author.email && { email: author.email }),
    ...(author.expertise_areas && author.expertise_areas.length > 0 && { 
      knowsAbout: author.expertise_areas 
    }),
    ...(sameAs.length > 0 && { sameAs }),
    worksFor: {
      "@type": "Organization",
      name: "iQ Texting",
    },
  };
};

/**
 * Generate full Person schema for author profile page
 */
export const generateAuthorProfileSchema = (author: AuthorProfile, postsCount: number = 0) => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    mainEntity: {
      ...generateAuthorPersonSchema(author),
      ...(author.credentials && { hasCredential: author.credentials }),
      ...(postsCount > 0 && { 
        author: {
          "@type": "CreativeWork",
          name: `${postsCount} blog posts`,
        }
      }),
    },
    url: author.author_slug ? `${baseUrl}/blog/author/${author.author_slug}` : baseUrl,
  };
};
